import React from 'react';
import useCondition from '../../useCondition';

export default () => {
  const {condition} = useCondition();

  if (condition?.isEmail === null || condition?.isEmail === undefined) {
    return null;
  }

  return (
    <div className="pb-4 border-b border-c-border flex flex-col gap-2 last-of-type:border-none">
      <div className="flex items-center gap-1">
        <h4 className="m-0 font-bold">メールアドレス</h4>
      </div>
      <div className="flex gap-1">
        <span className="text-sm inline-block border border-c-border rounded-sm bg-c-bg px-2">
          {condition?.isEmail ? 'メールアドレスあり' : 'メールアドレスなし'}
        </span>
      </div>
    </div>
  );
};
